import { render, staticRenderFns } from "./productsSlider.vue?vue&type=template&id=b8b11a22"
import script from "./productsSlider.vue?vue&type=script&lang=js"
export * from "./productsSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports